import { useEffect } from 'react'
import { z } from 'zod/v4'

import { CHAT_EVENT_LAYOUT_UPDATE } from './Chat.constants'

export const chatEventSchema = z.object({
  type: z.literal(CHAT_EVENT_LAYOUT_UPDATE),
  data: z.object({
    minimized: z.boolean(),
    height: z.number(),
    width: z.number(),
    boxShadow: z.string()
  })
})

type UseChatEventsListenerProps = {
  setHeight: (height: string) => void
  setWidth: (width: string) => void
  setBoxShadow: (boxShadow: string) => void
}

const useChatEventsListener = ({
  setHeight,
  setWidth,
  setBoxShadow
}: UseChatEventsListenerProps) => {
  useEffect(() => {
    const chatEventsListener = (event: MessageEvent) => {
      const expectedOrigin = new URL(window.waYesChatConfig.url).origin

      if (event.origin !== expectedOrigin) {
        return
      }

      const chatEvent = chatEventSchema.safeParse(event.data).data

      if (!chatEvent) {
        return
      }

      if (chatEvent.type === CHAT_EVENT_LAYOUT_UPDATE) {
        setHeight(
          chatEvent.data.minimized ? chatEvent.data.height.toString() : '100%'
        )
        setWidth(chatEvent.data.width.toString())
        setBoxShadow(chatEvent.data.boxShadow)
      }
    }

    window.addEventListener('message', chatEventsListener)

    return () => {
      window.removeEventListener('message', chatEventsListener)
    }
  }, [setBoxShadow, setHeight, setWidth])
}

export default useChatEventsListener
